import React, { useState } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { ShieldCheck, ArrowLeft } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const initialToken = params.get("token") || "";
  const [token, setToken] = useState(initialToken);
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) { setError("Passwords don't match"); return; }
    if (password.length < 6) { setError("Password must be at least 6 characters"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      setDone(true);
      setTimeout(() => navigate("/login", { replace: true }), 1500);
    } catch (e) {
      setError(formatApiError(e.response?.data?.detail) || e.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-6 py-16">
      <div className="w-full max-w-md">
        <Link to="/login" className="inline-flex items-center gap-1 text-sm font-semibold hover:text-[var(--brand-primary)]">
          <ArrowLeft className="w-4 h-4" /> Back to sign in
        </Link>
        <div className="label-eyebrow mt-6 flex items-center gap-1.5"><ShieldCheck className="w-3 h-3" /> Reset password</div>
        <h1 className="font-display font-black text-5xl tracking-tight mt-3">New password.</h1>

        {done ? (
          <div className="mt-10 border border-[#0F0F0F] p-6" data-testid="reset-success">
            <div className="font-display font-bold text-xl">Password updated.</div>
            <p className="text-sm text-[#5C5C5C] mt-2">Redirecting you to sign in…</p>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-10 space-y-5">
            <div>
              <label className="label-eyebrow block mb-2">Reset token</label>
              <input data-testid="reset-token" required value={token} onChange={(e) => setToken(e.target.value)}
                className="w-full border border-[#0F0F0F] bg-transparent px-4 py-3 rounded-sm font-mono text-sm"
                placeholder="Paste your token" />
            </div>
            <div>
              <label className="label-eyebrow block mb-2">New password</label>
              <input data-testid="reset-password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)}
                className="w-full border border-[#0F0F0F] bg-transparent px-4 py-3 rounded-sm" placeholder="At least 6 characters" />
            </div>
            <div>
              <label className="label-eyebrow block mb-2">Confirm new password</label>
              <input data-testid="reset-confirm" type="password" required minLength={6} value={confirm} onChange={(e) => setConfirm(e.target.value)}
                className="w-full border border-[#0F0F0F] bg-transparent px-4 py-3 rounded-sm" placeholder="Confirm" />
            </div>
            {error && <div data-testid="reset-error" className="text-sm text-[var(--brand-primary)]">{error}</div>}
            <button data-testid="reset-submit" disabled={loading} type="submit" className="btn-terra w-full">
              {loading ? "Updating…" : "Update password"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
